
//const feapiurl = "http://apievcustomer.de/pp/api/frontend/";
const feapiurl = "https://api.evolvejobs.de/pp/api/frontend/";

export default feapiurl;